// src/axiosConfig.js
import axios from "axios";
import { checkRequestContext, isAuthenticationRequest } from "./requestContext";

const api = axios.create({
  baseURL: "/api",
  timeout: 30000,
  withCredentials: true, // ca să trimită refresh cookie (mai ales dacă ai CORS)
});

api.interceptors.request.use((cfg) => {
  if (!isAuthenticationRequest(cfg)) {
    cfg._erpContext = checkRequestContext(cfg._erpContext);
  }
  const t = localStorage.getItem("token");
  if (t) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  const activeTenant = localStorage.getItem("active_tenant");
  if (activeTenant) {
    cfg.headers = cfg.headers || {};
    cfg.headers["X-Tenant"] = activeTenant;
  }
  const activeBranchId = localStorage.getItem("active_branch_id");
  if (activeBranchId) {
    cfg.headers = cfg.headers || {};
    cfg.headers["X-Branch-Id"] = activeBranchId;
  }
  return cfg;
});

let refreshPromise = null;

api.interceptors.response.use(
  (r) => {
    if (!isAuthenticationRequest(r.config)) checkRequestContext(r.config._erpContext);
    return r;
  },
  async (err) => {
    const status = err.response?.status;
    const original = err.config;
    if (original && !isAuthenticationRequest(original)) checkRequestContext(original._erpContext);

    // console.log(
    //   "[axios] ERROR",
    //   err.config?.method,
    //   err.config?.url,
    //   "status=",
    //   err.response?.status,
    // );

    // nu e 401 => lasă eroarea
    if (status !== 401) return Promise.reject(err);

    // dacă deja e refresh și a picat => logout
    if (original?.url?.includes("/auth/refresh")) {
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("auth-token-changed"));
      if (window.location.pathname !== "/login")
        window.location.href = "/login";
      return Promise.reject(err);
    }

    // evită loop infinit
    if (original._retry) {
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("auth-token-changed"));
      if (window.location.pathname !== "/login")
        window.location.href = "/login";
      return Promise.reject(err);
    }
    original._retry = true;
    // console.log("[axios] trying refresh...");
    try {
      if (!refreshPromise) {
        refreshPromise = api
          .post("/auth/refresh")
          .then((res) => {
            const newToken = res.data?.access_token;
            if (!newToken) throw new Error("No access_token from refresh");
            localStorage.setItem("token", newToken);
            window.dispatchEvent(new Event("auth-token-changed"));
            return newToken;
          })
          .finally(() => {
            refreshPromise = null;
          });
      }

      const newToken = await refreshPromise;

      // reîncearcă request-ul original cu token nou
      original.headers = original.headers || {};
      original.headers.Authorization = `Bearer ${newToken}`;
      return api.request(original);
    } catch (e) {
      if (e.code === "ERP_CONTEXT_CHANGED") return Promise.reject(e);
      localStorage.removeItem("token");
      window.dispatchEvent(new Event("auth-token-changed"));
      if (window.location.pathname !== "/login")
        window.location.href = "/login";
      return Promise.reject(err);
    }

    // console.log("[axios] refresh OK, retrying", original?.url);
  },
);

export default api;
